import { render, staticRenderFns } from "./RejectedOrders.vue?vue&type=template&id=888b4db8&"
import script from "./RejectedOrders.vue?vue&type=script&lang=js&"
export * from "./RejectedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports